import type { IconData } from '@stacksjs/iconify-core'

export const logoSpotify: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M30.47 9.14h-1.52V6.09h-1.53V4.57H25.9V3.05h-3.05V1.52h-3.04V0h-7.62v1.52H9.14v1.53H6.09v1.52H4.57v1.52H3.04v3.05H1.52v3.05H0v7.62h1.52v3.05h1.52v3.04h1.53v1.53h1.52v1.52h3.05v1.53h3.05V32h7.62v-1.52h3.04v-1.53h3.05v-1.52h1.52V25.9h1.53v-3.04h1.52v-3.05H32v-7.62h-1.53Zm-6.09 18.29h-3.05V25.9h-3.05v-1.52h-7.62v1.52H7.61v-1.52h1.53v-1.52h3.05v-1.53h3.04v1.53h6.1v1.52h1.52v1.52h1.53Zm3.04-7.62H25.9v1.52h-3.05v-1.52h-3.04v-1.52h-3.05v-1.53h-6.1v1.53H7.61v1.52H4.57v-1.52H3.04v-1.53h3.05v-1.52h3.05v-1.53h9.14v1.53h4.57v1.52h1.53v1.53h3.04Zm1.53-6.1H25.9v-1.52h-3.05v-1.52h-4.57V9.14h-7.62v1.53H6.09V9.14H4.57V7.62h3.04V6.09h3.05V4.57h9.15v1.52h1.52v1.53h3.05v1.52h1.52v1.53h3.05Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default logoSpotify
